import { BRAND_LABELS } from '@/defs/brand'
import { useReduxSelector } from '@/store/hooks'
import { selectors } from '@/store/selectors'

type Props = {
  variant: 'groupby' | 'sortby'
}

export const GalleryControlsPriceAlert = ({ variant }: Props) => {
  const preferredPriceSource = useReduxSelector(selectors.priceSources)[0]

  return (
    <>
      <span>{variant === 'groupby' ? 'Grouping' : 'Sorting'}</span> by first (left-most) price source in your settings.
      ({BRAND_LABELS[preferredPriceSource].label})
    </>
  )
}
